import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import Loader from "@/components/Loader/LoaderView";
import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';


export default {
  components: {
    Sidebar,
    Navbar,
    Loader
  },
  data() {
    return ({
      isSubmitting: false,
      event_ticket_instances: [],

    });
  },
  methods: {
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },

    newFormatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      return new Date(dateString).toLocaleString(undefined, options);
    },
    exportTicketsToCSV() {
      const table = $('.table').DataTable();
      const filteredData = table.rows({ search: 'applied' }).data();

      if (!filteredData || filteredData.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No ticket instances to export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      // CSV header for event tickets
      const csvHeader = [
        "First Name",
        "Last Name",
        "Email",
        "Event Name",
        "Ticket Name",
        "Ticket Code",
        "Purchased At"
      ].join(",");

      const csvRows = [];

      const dataArray = Array.from(filteredData); // Convert to array

      for (const row of dataArray) {
        // Find the matching ticket instance by user email or ID
        const instance = this.event_ticket_instances.find(i => i.email === row[3]);
        if (!instance) continue;

        csvRows.push(this.formatTicketCsvRow(instance));
      }

      const csvContent = csvHeader + "\n" + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "ticket_instances.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    formatTicketCsvRow(instance) {
      const row = [
        instance.first_name || '',
        instance.last_name || '',
        instance.email || '',
        instance.event_name || '',
        instance.ticket_name || '',
        instance.unique_code || '',
        instance.order_date ? this.newFormatDate(instance.order_date) : ''
      ];

      return row.join(',');
    },


    filter_ticket_instances() {
      const event_id = this.$route.params.event_id;
      this.isSubmitting = true;
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_ticket_instances/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({ event_id }),
          success: (data) => {
            this.event_ticket_instances = data.instances;
            this.isSubmitting = false;
            resolve();
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },

  },
  mounted() {
    this.user_details = get_user_details();
    this.filter_ticket_instances().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });

  }
};
